import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { PutJson } from '@awp/helpers/fetchReact';
import { REST_API, EventTypes } from '@awp/constants';
import { getAvalancheObservations } from '@awp/stores/avalancheSlice';
const EventDuplicateButton = ({ event, onDuplicate }) => {
  if (
    !event ||
    (event.EventTypeNm !== EventTypes.RoadClosure &&
      event.EventTypeNm !== EventTypes.AvalancheControl &&
      event.EventTypeNm !== EventTypes.AvalancheOccurrence)
  )
    return null;

  const canDuplicate = ['Created', 'Edited', 'Transmitted', 'Duplicated'].includes(event.Status);
  if (!canDuplicate) return null;

  const checkProperties = (event) => {
    const invalidLabels = [];
    if ((event.AvalTrType == '' && event.AvalSizeCd == '') || event.AvalTrType == '' || event.AvalSizeCd == '') {
      return invalidLabels;
    }
    const trMatch = triggerTypes?.find((x) => x.value === event.AvalTrType);
    const sizeMatch = sizeTypes?.find((x) => x.value === event.AvalSizeCd);

    if (!trMatch) {
      invalidLabels.push(
        `Processed event is not valid for duplication: code table value '${event.AvalTrType}' is not active`,
      );
    }

    if (!sizeMatch) {
      invalidLabels.push(
        `Processed event is not valid for duplication: code table value '${event.AvalSizeCd}' is not active`,
      );
    }

    return invalidLabels;
  };

  const isValidToDuplicate = (event) => {
    const eventInvalid = checkProperties(event);
    const childInvalid = (event?.ChildAvalancheProcessedEvents || []).flatMap((child) => checkProperties(child));

    const allInvalidLabels = [...eventInvalid, ...childInvalid];
    const uniqueInvalidLabels = Array.from(new Set(allInvalidLabels));

    return {
      isValid: uniqueInvalidLabels.length === 0,
      invalidLabels: uniqueInvalidLabels,
    };
  };

  const triggerTypes = useSelector((state) => getAvalancheObservations(state, 'aval_trig_type_cd'));
  const sizeTypes = useSelector((state) => getAvalancheObservations(state, 'aval_size_cd'));

  const url = REST_API.AVALANCHE_EVENT + event.EventId + '/clone';
  const handleDuplicate = async () => {
    PutJson(url)
      .then(async (response) => {
        if (response.ok) {
          toast.success('Event has been cloned');
          const clonedEventId = await response.json();
          onDuplicate(clonedEventId);
        } else {
          toast.error('Failed to clone an Event');
        }
      })
      .finally(() => {});
  };
  const { isValid, invalidLabels } = isValidToDuplicate(event);
  return isValid ? (
    <i className="fas fa-copy mx-1 my-1 awp-img-btn" title="Duplicate" onClick={() => handleDuplicate()} />
  ) : (
    <i className="fas fa-copy mx-1 my-1 awp-img-btn" style={{ color: '#ccc' }} title={`${invalidLabels.join('\n')}`} />
  );
};

EventDuplicateButton.propTypes = {
  event: PropTypes.any,
  onDuplicate: PropTypes.func,
};

export default EventDuplicateButton;
